<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader />
  
      <!-- Update User Form -->
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <h2>Update User Details</h2>
            <form @submit.prevent="handleUpdate">
              <!-- Name Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="name">Name</label>
                  <input type="text" class="form-control" id="name" v-model="form.name" placeholder="Enter Full Name" required>
                </div>
              </div>
  
              <!-- Email Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="email">Email</label>
                  <input type="email" class="form-control" id="email" v-model="form.email" placeholder="Enter Email Address">
                </div>
              </div>
  
              <!-- Password Input (Optional) -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="password">New Password (Optional)</label>
                  <input type="password" class="form-control" id="password" v-model="form.password" placeholder="Enter New Password">
                </div>
              </div>
  
              <!-- Password Confirmation Input (Optional) -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="password_confirmation">Confirm New Password</label>
                  <input type="password" class="form-control" id="password_confirmation" v-model="form.password_confirmation" placeholder="Confirm New Password">
                </div>
              </div>

              <!-- Language Selection -->
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label>Default Language</label>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" id="english" v-model="form.language" value="english">
                        <label class="form-check-label" for="english">English</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" id="french" v-model="form.language" value="french">
                        <label class="form-check-label" for="french">French</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" id="arabic" v-model="form.language" value="arabic">
                        <label class="form-check-label" for="arabic">Arabic</label>
                      </div>
                    </div>
                  </div>
  
              <!-- Buttons -->
              <div class="form-row">
                <div class="form-group col-12 d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary" @click="clearForm">Cancel</button>
                  <button type="submit" class="btn btn-primary" >Update</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  
      <!-- Footer -->
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
         form: {
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
      language: 'english' 
    },
        currentDate: '',
        currentTime: '',
        userId: null, 
        appId: null,
        token:null,
      };
    },
    mounted() {
        this.token = localStorage.getItem('authToken');
        this.appId = this.$route.params.appId
      this.updateDateTime();
      this.startDateTimeUpdate();
      this.fetchUserData(); 
    },
    methods: {
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        this.currentTime = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      },
      startDateTimeUpdate() {
        setInterval(() => {
          this.updateDateTime();
        }, 1000);
      },
      async fetchUserData() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          this.userId = this.$route.params.id; 
  
          const response = await fetch(`${this.$BASE_API_URL}/api/users/${this.userId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.token}`,
            },
          });
  
          if (!response.ok) {
            throw new Error('Failed to fetch user data');
          }
  
          const data = await response.json();
          this.form.name = data.data.name;
          this.form.email = data.data.email;
        } catch (error) {
          console.error('Error fetching user data:', error);
          this.$toast.error('Failed to fetch user details. Please try again.');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      async handleUpdate() {
        if (this.form.password && this.form.password !== this.form.password_confirmation) {
          this.$toast.error('Passwords do not match.');
          return;
        }
  
        // Prepare payload
        const payload = {
          name: this.form.name,
          email: this.form.email,
          appId: this.appId
        };
  
        if (this.form.password) {
          payload.password = this.form.password;
          payload.password_confirmation = this.form.password_confirmation;
        }
  
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const response = await fetch(`${this.$BASE_API_URL}/api/users/${this.userId}`, {
            method: 'PUT', // Use PUT or PATCH depending on your API
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.token}`,
            },
            body: JSON.stringify(payload),
          });
  
          const data = await response.json();
  
          if (response.ok) {
            this.$toast.success('User updated successfully!');
            this.$router.push('/users'); 
          } else {
            this.$toast.error('Update failed: ' + (data.message || 'Unknown error'));
          }
        } catch (error) {
          console.error('Error:', error);
          this.$toast.error('An error occurred. Please try again.');
          
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      clearForm() {
        this.form = {
          name: '',
          email: '',
          password: '',
          password_confirmation: '',
        };
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add your custom styles here */
  .class-1 {
    font-family: 'Poppins', sans-serif;
  }
  
  .logo_icon {
    width: 100px;
    height: auto;
  }
  
  .container {
    max-width: 800px;
    margin: 0 auto;
  }
  
  .form-control {
    border-radius: 5px;
    border: 1px solid;
    padding: 0.5rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .btn-primary {
    background-color: #007bff;
    border: none;
    color: white;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    border: none;
    color: white;
  }
  
  .txtfooter {
    margin-top: 2rem;
  }
  
  .btn-primary {
    background-color: #4caf50;
  }
  </style>